import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupSendExamSample(): void {
  applicationModuleRegistry.register({
    entry: 'SEND_EXAM_SAMPLE#9131',
    id: 'SEND_EXAM_SAMPLE#9131',
    name: 'module.send_exam_sample',
    route: ApplicationRoute.SEND_EXAM_SAMPLE,
    routes: [
      {
        main: true,
        name: 'function.send-container',
        route: ApplicationRoute.SEND_CONTAINER,
      }
    ]
  });
}
